import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import BrokerDetails from '../BrokerDetails';
import store, { brokerActions } from '@apply/adminStore';
import { useSelector } from 'react-redux';

const EditBrokerModal = () => {
    const { brokerState } = useSelector((state) => state);
    const { dispatch } = store;

    const handleClose = () => dispatch(brokerActions.setBrokerModalOpen({ openBrokerModal: false }));

    return (
        <Dialog
            maxWidth='lg'
            open={brokerState.openBrokerModal}
            onClose={handleClose}
            aria-labelledby='form-dialog-title'
        >
            <div className='modal-container'>
                <div className='modal-backdrop'></div>
                <div
                    className='modal'
                    tabIndex='-1'
                    role='dialog'
                >
                    <div
                        className='modal-dialog'
                        role='document'
                    >
                        <BrokerDetails />
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default EditBrokerModal;
